var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.671,
    height: 13.671,
    viewBox: "0 0 13.671 13.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification-icon",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27474",
    "data-name": "Path 27474",
    d: "M29.512,36.148h.531a1.593,1.593,0,1,0,3.185,0h.531a2.123,2.123,0,1,1-4.247,0Zm8.759-1.062v.266a.8.8,0,0,1-.8.8H25.8a.8.8,0,0,1-.8-.8v-.266a1.594,1.594,0,0,1,1.593-1.592V30.043a5.043,5.043,0,0,1,10.086,0v3.451A1.592,1.592,0,0,1,38.271,35.086Zm-1.6-1.061a.53.53,0,0,1-.528-.529V30.043a4.512,4.512,0,0,0-9.025,0V33.5a.53.53,0,0,1-.528.529,1.063,1.063,0,0,0-1.064,1.061v.266a.265.265,0,0,0,.266.265H37.475a.264.264,0,0,0,.266-.265v-.266A1.061,1.061,0,0,0,36.676,34.025Z",
    transform: "translate(-25 -25)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.ad6ccfedf3afacb77711967198d10a18.svg";
export { ForwardRef as ReactComponent };